<script type="text/javascript">
	import Switch from '@smui/switch';
	import LoadState from "../../Enums/LoadState";
	import { Paint } from "../../Map/MapLayerStyles";
	import ModalWindow from "../../UI/ModalWindow.svelte";
	import HotspotsStore from "./Store";
		
	let loadState = HotspotsStore.meta.loadState;
	let loaded = false;
	$: {
		loaded = $loadState === LoadState.LOADED;
	}

	let visible = HotspotsStore.meta.visible;
	HotspotsStore.meta.visible.subscribe((visible) => {
		if (visible) {
			HotspotsStore.actions.init();
		}
	});

	let lastUpdated = HotspotsStore.meta.lastUpdated;
	$: {
		$visible;
		$lastUpdated;
		HotspotsStore.actions.updateVisibility();
	}

	let tankerSTSHotspots = HotspotsStore.results.tanker;
	let cargoSTSHotspots = HotspotsStore.results.cargo;
	let fishingSTSHotspots = HotspotsStore.results.fishing;
	
	let tankerVisibility = HotspotsStore.meta.visibility.tanker;
	let cargoVisibility = HotspotsStore.meta.visibility.cargo
	let fishingVisibility = HotspotsStore.meta.visibility.fishing;

	$: {
		$lastUpdated;
	}
	$: {
		$tankerVisibility;
		$cargoVisibility;
		$fishingVisibility;
		HotspotsStore.actions.updateVisibility();
	}

</script>

<style>

.hotspot-key-item {
    overflow:hidden;
    margin-bottom:10px;
}
.hotspot-key-item .color-sq {
    margin:5px;
}
.hotspot-key-item p {
    margin:5px;
    margin-left:5px;
}
.hotspot-switch-container {
	padding-top:7px;
	padding-right:10px;
	padding-left:5px;
	float:left;
}

</style>

<ModalWindow
	title={`Ship-to-ship Hotspots`}
	hasCloseButton={true}
	hasBackground={false}
	resizable={true}
	draggable={true}
	fullscreen={false}
	padding={false}
	position="top-right"
	height="70%"
	bind:open={$visible} >

    <div class="content padding" style="overflow:hidden;">
        <p><b>Key</b></p>

        <div class="hotspot-key-item">
			<div class='hotspot-switch-container'><Switch bind:checked={$tankerVisibility}/></div>
            <div class='fl color-sq' style={"background-color: " + Paint.hotspots.orange["fill-color"] + ";"}></div>
            <p class='fl'>Tanker</p>
            <p class='fr'>({$tankerSTSHotspots.features.length})</p>
		</div>
       
        <div class="hotspot-key-item">
			<div class='hotspot-switch-container'><Switch bind:checked={$cargoVisibility}/></div>
            <div class='fl color-sq' style={"background-color: " + Paint.hotspots.green["fill-color"] + ";"}></div>
            <p class='fl'>Cargo</p>
            <p class='fr'>({$cargoSTSHotspots.features.length})</p>
        </div>

        <div class="hotspot-key-item">
			<div class='hotspot-switch-container'><Switch bind:checked={$fishingVisibility}/></div>
            <div class='fl color-sq' style={"background-color: " + Paint.hotspots.blue["fill-color"] + ";"}></div>
            <p class='fl'>Fishing</p>
            <p class='fr'>({$fishingSTSHotspots.features.length})</p>
        </div>
       
        
    </div>

</ModalWindow>

